import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';  // Import Bootstrap
import App from './App';

// Create the necessary HTML structure directly in JavaScript (Not needed in react it cause render problem)
// document.write(`
//   <!DOCTYPE html>
//   <html lang="en">
//   <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>Real-Time Collaboration Tool</title>
//   </head>
//   <body>
//     <div id="root"></div>
//   </body>
//   </html>
// `);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

